import store from '@state/store';

export default [
  {
    path: '/',
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        next({ name: 'clients' });
      },
    },
  },
  {
    path: '/login',
    name: 'login',
    component: () => lazyLoadView(import('@views/login.vue')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          next({ name: 'clients' });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: '/register',
    name: 'register',
    component: () => lazyLoadView(import('@views/register.vue')),
  },
  {
    path: '/forgot-password/:type',
    name: 'forgot-pass',
    component: () => lazyLoadView(import('@views/forgot-pass.vue')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          next({ name: 'clients' });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: '/forgot-password-confirm/:type',
    name: 'forgot-pass-confirm',
    component: () => lazyLoadView(import('@views/forgot-pass-confirm.vue')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          next({ name: 'clients' });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: '/equipments',
    name: 'equipment',
    component: () => lazyLoadView(import('@views/equipment/equipment.vue')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        !store.getters['auth/roles'].includes('isAdmin')
          ? next({ name: 'trainers' })
          : next();
      },
    },
  },
  {
    path: '/exercises',
    name: 'exercises',
    component: () => lazyLoadView(import('@views/exercises/exercises.vue')),
    meta: {
      authRequired: true,
      breadcrumb: 'Exercises',
    },
  },
  {
    path: '/exercises/:id',
    name: 'exerciseDetail',
    props: true,
    component: () =>
      lazyLoadView(import('@views/exercises/exercise-detail.vue')),
    meta: {
      authRequired: true,
      breadcrumb: 'Exercises',
      async beforeResolve(routeTo, routeFrom, next) {
        if (!routeTo.params.exercise && routeTo.params.id) {
          await store
            .dispatch('exercise/getExercise', {
              exerciseId: routeTo.params.id,
              orgId: store.getters['auth/userOrgId'],
              trainerId: '0',
            })
            .then((res) => {
              if (!res) {
                next({ name: '404' });
              } else {
                routeTo.params.exercise = res.exercise;
                next();
              }
            });
        } else {
          next();
        }
      },
    },
  },
  {
    path: '/fitnessTypes',
    name: 'fitnessTypes',
    component: () => lazyLoadView(import('@views/fitness-type/fitnessTypes.vue')),
    meta: {
      authRequired: true,
      breadcrumb: 'Fitness Types',
      beforeResolve(routeTo, routeFrom, next) {
        !store.getters['auth/roles'].includes('isAdmin')
          ? next({ name: 'trainers' })
          : next();
      },
    },
  },
  {
    path: '/workouts',
    name: 'workouts',
    component: () => lazyLoadView(import('@views/workouts/workouts.vue')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/workouts/:id',
    name: 'workoutDetail',
    props: true,
    component: () => lazyLoadView(import('@views/workouts/workout-detail.vue')),
    meta: {
      authRequired: true,
      breadcrumb: 'Workout Detail',
      beforeResolve(routeTo, routeFrom, next) {
        routeTo.params.workout ? next() : next({ name: 'workouts' });
      },
    },
  },
  {
    path: '/programs',
    name: 'programs',
    component: () => lazyLoadView(import('@views/programs/programs.vue')),
    meta: {
      authRequired: true,
      breadcrumb: 'Programs',
    },
  },
  {
    path: '/programs/:id',
    name: 'programDetail',
    props: true,
    component: () => lazyLoadView(import('@views/programs/program-detail.vue')),
    meta: {
      authRequired: true,
      breadcrumb: 'Program Detail',
      async beforeResolve(routeTo, routeFrom, next) {
        if (!routeTo.params.program && routeTo.params.id) {
          await store
            .dispatch('program/getProgram', {
              programId: routeTo.params.id,
              orgId: store.getters['auth/userOrgId'],
              trainerId: store.getters['auth/trainerId'],
              userId: '0',
            })
            .then((res) => {
              if (!res) {
                next({ name: '404' });
              } else {
                routeTo.params.program = res.program;
                next();
              }
            });
        } else {
          next();
        }
      },
    },
  },
  // {
  //   path: '/taxonomy',
  //   name: 'taxonomy',
  //   component: () => lazyLoadView(import('@views/taxonomy/taxonomy.vue')),
  // },
  {
    path: '/trainers',
    name: 'trainers',
    component: () => lazyLoadView(import('@views/trainers/trainers.vue')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        !store.getters['auth/roles'].includes('isAdmin')
          ? next({ name: 'clients' })
          : next();
      },
    },
  },
  {
    path: '/trainers/:id',
    name: 'trainerDetail',
    props: true,
    component: () => lazyLoadView(import('@views/trainers/trainer-detail.vue')),
    meta: {
      authRequired: true,
      async beforeResolve(routeTo, routeFrom, next) {
        if (!routeTo.params.trainer && routeTo.params.id) {
          await store
            .dispatch('trainer/getTrainer', {
              trainerId: routeTo.params.id,
              orgId: store.getters['auth/userOrgId'],
            })
            .then((res) => {
              if (!res) {
                next({ name: '404' });
              } else {
                routeTo.params.trainer = res.trainer;
                next();
              }
            });
        } else {
          next();
        }
      },
    },
  },
  {
    path: '/clients',
    name: 'clients',
    component: () => lazyLoadView(import('@views/clients/clients.vue')),
    meta: {
      authRequired: true,
      async beforeResolve(routeTo, routeFrom, next) {
        if (store.getters['auth/roles'].includes('isAdmin')) {
          next({ name: 'trainers' });
        } else if (store.getters['client/allClientsCount'] <= 1) {
          await store
            .dispatch('client/getAllClient', {
              trainerId: store.getters['auth/trainerId'],
            })
            .then((res) => {
              if (!res) {
                next({ name: 'clients' });
              } else {
                next();
              }
            });
        } else {
          next();
        }
      },
    },
  },
  {
    path: '/clients/:id',
    name: 'clientDetail',
    props: true,
    component: () => lazyLoadView(import('@views/clients/client-detail.vue')),
    meta: {
      authRequired: true,
      async beforeResolve(routeTo, routeFrom, next) {
        if (!routeTo.params.client && routeTo.params.id) {
          const clientObj = {
            _id: routeTo.params.id,
            trainer_id: store.getters['auth/trainerId'],
          };
          await store
            .dispatch('client/getClient', { clientObj })
            .then((res) => {
              if (!res) {
                next({ name: 'clients' });
              } else {
                store.commit('client/setAllClient', [res]);
                store.commit('client/setAllClientClone', [res]);
                store.commit('client/setSelectedClient', { ...res });
                routeTo.params.client = res;
                next();
              }
            });
        } else {
          next();
        }
        next();
      },
    },
    children: [
      {
        path: 'messages',
        name: 'clientMessages',
        component: () =>
          lazyLoadView(import('@views/clients/client-messages.vue')),
      },
      {
        path: 'photos',
        name: 'clientPhotos',
        component: () =>
          lazyLoadView(import('@views/clients/client-photos.vue')),
      },
      {
        path: 'about',
        name: 'clientAbout',
        component: () =>
          lazyLoadView(import('@views/clients/client-about.vue')),
      },
      {
        path: 'program',
        name: 'clientProgram',
        component: () =>
          lazyLoadView(import('@views/clients/client-program.vue')),
      },
      {
        path: 'subscription',
        name: 'clientSubscription',
        component: () =>
          lazyLoadView(import('@views/clients/client-subscription.vue')),
      },
      {
        path: 'nutrition',
        name: 'clientNutrition',
        component: () =>
          lazyLoadView(import('@views/clients/client-nutrition.vue')),
      },
      {
        path: 'check-in',
        name: 'clientCheckIn',
        component: () =>
          lazyLoadView(import('@views/clients/client-check-in.vue')),
      },
      {
        path: 'notes',
        name: 'clientTrainerNotes',
        component: () =>
          lazyLoadView(import('@views/clients/client-trainer-notes.vue')),
      },
    ],
  },
  {
    path: '/circuits',
    name: 'circuits',
    component: () => lazyLoadView(import('@views/circuits/circuits.vue')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/messages',
    name: 'messages',
    component: () => lazyLoadView(import('@views/messages/messages.vue')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/learning',
    name: 'learning',
    component: () => lazyLoadView(import('@views/cohorts/cohort-list.vue')),
    meta: {
      authRequired: true,
      async beforeResolve(routeTo, routeFrom, next) {
        await store.dispatch('learn/getCohorts').then((res) => {});
        if (store.getters['auth/isTrainerEnrolledInACohort']) {
          next({ name: 'fyf5' });
        } else if (store.state.auth.currentUser.trainer.learningEnabled) {
          next();
        } else {
          next({ name: 'clients' });
        }
      },
    },
  },
  {
    path: '/learning/FYF5',
    name: 'fyf5',
    component: () => lazyLoadView(import('@views/cohorts/fyf5.vue')),
    meta: {
      authRequired: true,
      async beforeResolve(routeTo, routeFrom, next) {
        await store.dispatch('learn/getCohorts').then((res) => {});
        if (store.getters['auth/isTrainerEnrolledInACohort']) {
          next();
        } else if (store.state.auth.currentUser.trainer.learningEnabled) {
          next({ name: 'learning' });
        } else {
          next({ name: 'clients' });
        }
      },
    },
  },
  {
    path: '/learning/FYF5/:id',
    name: 'fyf5ModuleDetail',
    props: true,
    component: () => lazyLoadView(import('@views/cohorts/fyf5-module.vue')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        routeTo.params.module ? next() : next({ name: 'fyf5' });
      },
    },
  },
  {
    path: '/nutrition',
    name: 'nutrition',
    component: () => lazyLoadView(import('@views/nutrition/nutrition.vue')),
    meta: {
      authRequired: true,
    },
    children: [
      {
        path: 'meal-plans',
        name: 'mealPlans',
        component: () =>
          lazyLoadView(import('@views/nutrition/meal-plans.vue')),
      },
      {
        path: 'recipes',
        name: 'recipes',
        component: () => lazyLoadView(import('@views/nutrition/recipes.vue')),
      },
    ],
  },
  {
    path: '/nutrition/meal-plans/:id',
    name: 'platelistDetail',
    props: true,
    component: () =>
      lazyLoadView(import('@views/nutrition/meal-plan-detail.vue')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        routeTo.params.platelist ? next() : next({ name: 'mealPlans' });
      },
    },
  },
  {
    path: '/recipes/:id',
    name: 'recipeDetail',
    props: true,
    component: () => lazyLoadView(import('@views/nutrition/recipe-detail.vue')),
    meta: {
      authRequired: true,
      async beforeResolve(routeTo, routeFrom, next) {
        if (!routeTo.params.recipe && routeTo.params.id) {
          await store
            .dispatch('recipe/getRecipe', {
              recipeId: routeTo.params.id,
            })
            .then((res) => {
              if (!res) {
                next({ name: '404' });
              } else {
                store.commit('recipe/setSelectedRecipe', {
                  ...res,
                  ...store.state.recipe.recipeDetails,
                });
                routeTo.params.recipe = res;
                next();
              }
            });
        } else {
          next();
        }
      },
    },
  },
  {
    path: '/products',
    name: 'products',
    component: () => lazyLoadView(import('@views/products.vue')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => lazyLoadView(import('@views/profile.vue')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/profile/:username',
    name: 'username-profile',
    component: () => lazyLoadView(import('@views/profile.vue')),
    meta: {
      authRequired: true,
      // HACK: In order to share data between the `beforeResolve` hook
      // and the `props` function, we must create an object for temporary
      // data only used during route resolution.
      tmp: {},
      beforeResolve(routeTo, routeFrom, next) {
        store
          // Try to fetch the user's information by their username
          .dispatch('users/fetchUser', { username: routeTo.params.username })
          .then((user) => {
            // Add the user to `meta.tmp`, so that it can
            // be provided as a prop.
            routeTo.meta.tmp.user = user;
            // Continue to the route.
            next();
          })
          .catch(() => {
            // If a user with the provided username could not be
            // found, redirect to the 404 page.
            next({ name: '404', params: { resource: 'User' } });
          });
      },
    },
    // Set the user from the route params, once it's set in the
    // beforeResolve route guard.
    props: (route) => ({ user: route.meta.tmp.user }),
  },
  {
    path: '/prospects',
    name: 'prospects',
    component: () => lazyLoadView(import('@views/prospects/prospects.vue')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/prospects/:id',
    name: 'prospectDetail',
    props: true,
    component: () =>
      lazyLoadView(import('@views/prospects/prospect-detail.vue')),
    meta: {
      authRequired: true,
      async beforeResolve(routeTo, routeFrom, next) {
        if (!routeTo.params.prospect && routeTo.params.id) {
          await store
            .dispatch('prospect/getProspect', routeTo.params.id)
            .then((res) => {
              if (res) {
                routeTo.params.prospect = res.prospect;
                next();
              }
            })
            .catch((err) => {
              if (err.response.status === 502) {
                store.commit('modal/setNotifyModalContext', {
                  textMain: 'Something went wrong!',
                  textSecond: 'Please try again.',
                  retry: true,
                  request: 'getProspect',
                  params: { id: routeTo.params.id },
                });
                routeTo.params.prospect = {};
                next();
              }
            });
        } else {
          next();
        }
      },
    },
    children: [
      {
        path: 'profile',
        name: 'prospectProfile',
        component: () =>
          lazyLoadView(import('@views/prospects/prospect-profile.vue')),
      },
      {
        path: 'messages',
        name: 'prospectMessages',
        component: () =>
          lazyLoadView(import('@views/prospects/prospect-messages.vue')),
      },
    ],
  },
  {
    path: '/terms',
    name: 'terms',
    component: () => lazyLoadView(import('@views/terms/terms.vue')),
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => lazyLoadView(import('@views/terms/privacy.vue')),
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      async beforeResolve(routeTo, routeFrom, next) {
        await store.dispatch('auth/logOut');
        store.dispatch('clearAll');
        next({ name: 'login' });
      },
    },
  },
  {
    path: '/404',
    name: '404',
    component: require('@views/_404.vue').default,
    // Allows props to be passed to the 404 page through route
    // params, such as `resource` to define what wasn't found.
    props: true,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },
];

// Lazy-loads view components, but with better UX. A loading view
// will be used if the component takes a while to load, falling
// back to a timeout view in case the page fails to load. You can
// use this component to lazy-load a route with:
//
// component: () => lazyLoadView(import('@views/my-view'))
//
// NOTE: Components loaded with this strategy DO NOT have access
// to in-component guards, such as beforeRouteEnter,
// beforeRouteUpdate, and beforeRouteLeave. You must either use
// route-level guards instead or lazy-load the component directly:
//
// component: () => import('@views/my-view')
//
function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    // A component to use while the component is loading.
    loading: require('@views/_loading.vue').default,
    // Delay before showing the loading component.
    // Default: 200 (milliseconds).
    delay: 400,
    // A fallback component in case the timeout is exceeded
    // when loading the component.
    error: require('@views/_timeout.vue').default,
    // Time before giving up trying to load the component.
    // Default: Infinity (milliseconds).
    timeout: 10000,
  });

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      // Transparently pass any props or children
      // to the view component.
      return h(AsyncHandler, data, children);
    },
  });
}
